/**
 * Apaga a sessão do navegador preservando o que sobrevive a ela.
 *
 * Existe porque `localStorage.clear()` no logout levava junto o
 * `device_token` -- o "lembrar este dispositivo como seguro". O efeito era
 * marcar a caixa, sair, e na volta o sistema pedir o código de novo: o
 * dispositivo confiável durava menos que a sessão que ele deveria sobreviver.
 *
 * O sintoma no banco era claro: 14 registros em `cookiedevice` para o mesmo
 * usuário, todos válidos e nenhum reaproveitado -- um por login.
 *
 * O `device_token` é de propósito mais longevo que a sessão: 30 dias, contra
 * as horas do JWT. Ele é o que dispensa o 2FA no próximo login, e apagá-lo ao
 * sair anula a funcionalidade inteira.
 */

/**
 * Chaves que NÃO são sessão e por isso ficam.
 *
 * Só entra aqui o que precisa atravessar o logout por desenho. Na dúvida,
 * deixe de fora: o padrão é limpar.
 */
export const CHAVES_PRESERVADAS = ['device_token', 'locale'];

/**
 * @param {Storage} armazenamento  injetável para teste
 */
export function limparSessao(armazenamento = globalThis.localStorage) {
    if (!armazenamento) return;

    const guardado = new Map();

    for (const chave of CHAVES_PRESERVADAS) {
        const valor = armazenamento.getItem(chave);
        if (valor !== null && valor !== '') {
            guardado.set(chave, valor);
        }
    }

    armazenamento.clear();

    for (const [chave, valor] of guardado) {
        armazenamento.setItem(chave, valor);
    }
}
